import type { LinkedCardResponse, LinkedPaymentMethodType } from "@shared/api/subscription.api";

const getCardBrandName = (brand?: string): string => {
  if (!brand) {
    return "Карта";
  }
  const brandLower = brand.toLowerCase();
  if (brandLower.includes("visa")) {
    return "Visa";
  }
  if (brandLower.includes("master")) {
    return "Mastercard";
  }
  if (brandLower.includes("mir")) {
    return "МИР";
  }
  if (brandLower.includes("maestro")) {
    return "Maestro";
  }
  return brand;
};

// ЮKassa сохраняет для автоплатежей не только карту
const PAYMENT_METHOD_LABELS: Record<Exclude<LinkedPaymentMethodType, "card">, string> = {
  sberpay: "SberPay",
  sbp: "СБП",
  tpay: "T-Pay",
  yoomoney: "ЮMoney",
  unknown: "Привязанный способ оплаты"
};

/** «Visa •••• 1234» или название способа оплаты, если это не карта */
export const getPaymentMethodDisplay = (cardInfo: LinkedCardResponse): string => {
  if (cardInfo.type && cardInfo.type !== "card") {
    return PAYMENT_METHOD_LABELS[cardInfo.type];
  }
  const brandName = getCardBrandName(cardInfo.brand);
  return cardInfo.last4 ? `${brandName} •••• ${cardInfo.last4}` : brandName;
};
